<!-- Error Block -->
<div class="error-container" aria-live="assertive">
  <div class="alert valign-children-middle checkout-error" *ngIf='setError'>
    <div class="alert-error" aria-label="Alert.">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div>
      <h2 *ngIf='errorFlag'>Something isn't working</h2>
      <h2 *ngIf='errorBanFlag'>Need valid billing account number</h2>
      <p>{{ErrorMessage}}</p>
    </div>
  </div>
  <div class="alert valign-children-middle" *ngIf='invalidFan'>
    <div class="alert-info" aria-label="Info.">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div>
      <h2>{{fanMessage}}</h2>
    </div>
  </div>
</div>
<!-- Error Block End -->
<form [formGroup]="billingpaymentform" *ngIf="cart !== null" autocomplete="off">
  <div class="row">
    <div class="col-sm-12 col-md-6 col-md-offset-3">
      <!-- Foundation Block -->
      <p> Select the account you want to use for billing. </p>
      <div class="row" *ngIf='showFanDropDown'>
        <!-- Foundation No Selection -->
        <label class="col-md-12 col-sm-12" for="fandropdown">Foundation account</label>
        <div class="col-sm-9 col-md-6">
          <app-dropdown [labelId]="'fandropdown'" [options]="fanNumbers" [placeholder]="dropDownPlaceholder" [prePopulateValue]="selectedFan"
            (selectEmit)="selected($event)"></app-dropdown>
        </div>
        <div class="col-sm-3 col-md-3 pad-left-0">
          <button class="btn btn-secondary btn-go" (click)="selectGoFan()" aria-label="Go.">  Go  </button>
        </div>
        <!--<a href="javascript:void(0)" class="btn btn-link text-center" (click)="cancel()">Cancel</a>-->
      </div>
      <!-- Foundation Selection End -->

      <div class="row" *ngIf='!showFanDropDown'>
        <!-- Wireless After Selection -->
        <label class="col-md-12 col-sm-12 data-label">Foundation account</label>
        <div class="col-sm-12 col-md-12">
          <p><strong>{{shownFan}}</strong><span class="separator" *ngIf='editFbtn'>|</span><a *ngIf='editFbtn' aria-label="Select a new foundation account."
              href="javascript:void(0);" (click)='editFan()'>Edit</a></p>
        </div>
      </div>
      <!-- Foundation After Selection End -->
      <!-- Foundation Block End -->

      <div *ngIf='banSectionEnable'>
        <!-- Billing Block Start -->

        <div class="row" *ngIf='showBanDropDown  && !banField'>
          <!-- Billing Account-->
          <label for="ban_input" class="col-md-12 col-sm-12">Billing account</label>
          <div class="col-sm-9 col-md-6">
            <div>
              <app-dropdown [labelId]="'ban_input'" [attr.aria-describedby]="formErrors.ban ? 'ban-error' : null" [options]="banNumbers"
                [placeholder]="dropbanDownPlaceholder" [prePopulateValue]="selectedBan" (selectEmit)="selectedBanNumber($event)"></app-dropdown>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <button aria-label="Go." class="btn btn-secondary btn-go" (click)='checkBanEntered()' [disabled]='!billingpaymentform.valid'>  Go  </button>
          </div>
          <div id="ban-error" *ngIf="formErrors.ban" class="text-danger marleft-20" tabindex="0">
            {{ formErrors.ban }}
          </div>
        </div>
        <!-- Billing Account text field section-->
        <div class="form-group" *ngIf='showBanDropDown && banField'>
          <label for="ban_input" class="col-md-12 col-sm-12">Billing account</label>
          <div class="col-sm-9 col-md-6">
            <div class="search">
              <input type="search" id='ban_input' aria-describedby="ban-error-field" maxlength="12" class="form-control" [class.text-error]="formErrors.ban"
                placeholder="Search" formControlName="ban">
              <span class="search-icon" (keypress)='checkBanEntered($event)' aria-label="Search for a new billing account." (click)='checkBanEntered()'><i tabindex="0" aria-hidden="true" class = "icon-controls-magnifyingglass"> </i> </span>
            </div>
            <div id="ban-error-field" *ngIf="formErrors.ban" class="text-danger marleft-20" tabindex="0">
              {{ formErrors.ban }}
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <button class="btn btn-secondary btn-go" (click)='checkBanEntered()' aria-label="Go." [disabled]="billingpaymentform.controls.ban.status === 'INVALID'">  Go  </button>
          </div>
        </div>
        <!-- Billing Account text field section End-->

        <!-- Billing Account End -->
        <div class="row" *ngIf='!showBanDropDown'>
          <!-- Billing After Selection -->
          <label class="col-md-12 col-sm-12 data-label">Billing account</label>
          <div class="col-sm-12 col-md-12">
            <p><strong>{{shownBan}}</strong><span class="separator" *ngIf='editBbtn'>|</span><a *ngIf='editBbtn' (click)='editBan()' href="javascript:void(0);"
                aria-label="Select a new billing account.">Edit</a></p>
          </div>
        </div>
        <!-- Billing After Selection End -->
        <!-- Billing Block End -->
      </div>

      <!-- Wireless Selection Start -->
      <div *ngIf='ctnSectionEnable'>
        <!-- Wireless Account before selection-->
        <div class="row" *ngIf="showCtnDropDown">
          <label class="col-md-12 col-sm-12" for="ctninput">Wireless number</label>
          <div class="col-sm-9 col-md-6">
            <div class="search">
              <!--<label for="ctninput"><div class="hide-element">ctn number</div></label>-->
              <input type="search" id='ctninput' [attr.aria-describedby]="formErrors.ctn? 'ctn-error' : null" maxlength="12" (keypress)='ctnChange($event)'
                (focus)='ctnFocus($event)' (blur)='ctnBlur($event)' class="form-control" [class.text-error]="formErrors.ctn"
                placeholder="Search" formControlName="ctn">
              <span class="search-icon" (keypress)='matchCtn($event)' (click)='matchCtn()'><i tabindex="0" class = "icon-controls-magnifyingglass" aria-hidden="true"> </i> </span>
            </div>
            <div id="ctn-error" *ngIf="formErrors.ctn" class="text-danger marleft-20" tabindex="0">
              {{ formErrors.ctn }}
            </div>
          </div>
          <div class="col-sm-3 col-md-3 pad-left-0">
            <button class="btn btn-secondary btn-go" (click)='matchCtn()' [disabled]='!billingpaymentform.valid' aria-label="Go.">  Go  </button>
          </div>
        </div>

        <div class="row" *ngIf='!showCtnDropDown'>
          <!-- Wireless account After Selection -->
          <label class="col-md-12 col-sm-12 data-label">Wireless number</label>
          <div class="col-sm-12 col-md-12">
            <p><strong>{{selectedCtn}}</strong><span class="separator" *ngIf='editCbtn'>|</span><a *ngIf='editCbtn' (click)='editCtn()'
                href="javascript:void(0);" aria-label="Select a new wireless number.">Edit</a></p>
          </div>
        </div>
      </div>
      <!-- Wireless Account End -->

      <!-- Wireless Block End -->
      <hr class="top-bottom" />
      <div class="line-footer text-right">
        <button class="btn btn-secondary btn-block pull-right" *ngIf='continueToProdConfig' disabled (click)='setCartObj()' aria-label="Enter the required details to continue.">Continue</button>
        <button class="btn btn-secondary btn-block pull-right" *ngIf='!continueToProdConfig' (click)='setCartObj()' aria-label="Continue.">Continue</button>
        <a href="javascript:void(0)" class="btn btn-link btn-block" (click)='goBackToCart()'> Back </a>
      </div>
    </div>
  </div>
</form>

<!-- Remove product modal -->
<div *ngIf="removeProd">
  <app-modal [showModal]="removeProd" [modalClass]="modalClass">
    <app-confirm-modal [modalPopupObject]='removeProductModalPopup' (modalOutput)="removeProduct($event)"></app-confirm-modal>
  </app-modal>
</div>